import React from 'react';
import styles from './SidebarMenuItem.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function SidebarMenuItem({text, icon}) {
    return (
        <div className={styles.container}>
            <FontAwesomeIcon className={styles.icon} icon={icon} />
            <span>{text}</span>
        </div>
    )
}

export default SidebarMenuItem;
